import { render, staticRenderFns } from "./BatchCardSkeleton.vue?vue&type=template&id=180f6926&scoped=true"
import script from "./BatchCardSkeleton.vue?vue&type=script&lang=js"
export * from "./BatchCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BatchCardSkeleton.vue?vue&type=style&index=0&id=180f6926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f6926",
  null
  
)

export default component.exports